import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";

export default function ModalCenter1(props) {
    return (
      <Modal
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Lavanderia Valentim Negri
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <h4>Seu depoimento foi publicado!</h4>
          <p>
            Muito obrigado por nos deixar uma avaliação, isso nos motiva a
            continuar entregando um serviço de qualidade.
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={props.onHide}>Fechar</Button>
        </Modal.Footer>
      </Modal>
    );
  }